import React from "react";

import { useIntl } from "react-intl";

import { Territory } from "@mapmycustomers/shared/types/entity";
import { Button } from "@mapmycustomers/ui";

import { useMap } from "@app/component/map/FeaturedMap";
import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";
import OverlayView from "@app/component/map/FeaturedMap/essentials/OverlayView";

import styles from "./TerritoryPopover.module.scss";

interface Props {
  onHide: () => void;
  onOpen?: (territory: Territory) => void;
  position: google.maps.LatLng | google.maps.LatLngLiteral;
  territories: Territory[];
}

const TerritoryPopover: React.FC<Props> = ({ onHide, onOpen, position, territories }) => {
  const intl = useIntl();
  const { map } = useMap();
  return (
    <OverlayView map={map} onClickOutside={onHide} position={position}>
      <div className={styles.container}>
        <div className={styles.title}>
          {intl.formatMessage({
            id: "map.feature.territory.popover",
            defaultMessage: "Select territory to open",
            description: "Title of the Select Territory popover",
          })}
        </div>
        <div className={styles.list}>
          {territories.map((territory) => (
            <div className={styles.item} key={territory.id}>
              <div className={styles.label}>{territory.name}</div>
              <Interactive className={styles.button}>
                <Button onClick={() => onOpen?.(territory)} size="small" type="primary">
                  {intl.formatMessage({
                    id: "map.feature.territory.popover.openButton",
                    defaultMessage: "Open",
                    description: "Open button in territory popover",
                  })}
                </Button>
              </Interactive>
            </div>
          ))}
        </div>
      </div>
    </OverlayView>
  );
};

export default TerritoryPopover;
